export default __webpack_public_path__ + "static/media/Group9162.44205a38.svg";